import "./index.scss";

import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Axios from "Source/axiosPool";
import { showToast } from "Source/globalFunction";

import Avatar from "Components/common/Avatar/Avatar";
import Checkbox from "Components/common/Checkbox/Checkbox";

@connect(store => {
    return {
        project: store.project,
        loggedUser: store.loggedUser,
        workstreamForm: store.workstreamForm
    };
})

class AccountUsers extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isClose: false,
            members: []
        }

        _.map(["onSelectUsers", "onSelectAll", "onSubmit"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    shouldComponentUpdate( nextProps ) {
        if( !_.isEqual( nextProps.workstreamForm.users, this.props.users ) ) {
            this.setState({
                ...this.state,
                members: nextProps.users.map( u => u.id )
            });
        }

        return true;
    }

    onSelectUsers(u) {
        const { dispatch, workstreamForm } = this.props;

        dispatch({ type: "UPDATE_WORKSTREAM_FORM_FIELD", field: {
            id: "users",
            value: workstreamForm.fields.users.map( m => { 
                if( m.id === u ) {
                    return {
                        ...m,
                        isSelected: m.isSelected ? false : true
                    }
                } 

                return m;
            }) 
        }});
    }

    onSelectAll() {
        const { workstreamForm, dispatch } = this.props;
        const isCheckedAll = workstreamForm.fields.users.length === workstreamForm.fields.users.filter( u => u.isSelected ).length;

        dispatch({ type: "UPDATE_WORKSTREAM_FORM_FIELD", field: {
            id: "users",
            value: workstreamForm.fields.users.map( m => {
                if( isCheckedAll ) {
                    return {
                        ...m,
                        isSelected: false
                    }
                }

                return {
                    ...m,
                    isSelected: true
                }
            })
        }});
    }

    onSubmit() {
        const { dispatch, project, loggedUser, workstreamForm } = this.props;
        const isKeyInDetails = (key) => workstreamForm.fields.details.indexOf( key ) > -1;
        const url = "api/workstream";
        const params = {
            color: workstreamForm.fields.color,
            dateUpdated: moment(),
            description: workstreamForm.fields.description,
            isActive: 1,
            isTemplate: workstreamForm.fields.isTemplate,
            numberOfHours: workstreamForm.fields.hours,
            projectId: project.Selected.id,
            responsible: workstreamForm.fields.workstreamLead.value,
            typeId: workstreamForm.fields.type.value,
            userId: loggedUser.data.id,
            workstream: workstreamForm.fields.name,
            workstreamTemplate: workstreamForm.fields.template.value,
            setting: {
                assignee: isKeyInDetails("assignee") ? 1 : 0,
                reviewer: isKeyInDetails("reviewer") ? 1 : 0,
                approver: isKeyInDetails("approver") ? 1 : 0,
                dependency: isKeyInDetails("dependency") ? 1 : 0,
                applicablePeriod: isKeyInDetails("applicablePeriod") ? 1 : 0,
                description: isKeyInDetails("description") ? 1 : 0,
            },
            includeUsers: workstreamForm.fields.users.filter( m => m.isSelected ).map( m => m.id )
        }

        dispatch({ type: "SET_SCREEN_LOADER", Loading: true });

        Axios.post(url, params)
            .then( response => {
                if( response ) {
                    dispatch({ type: "ADD_WORKSTREAM", data: {...response.data, workstreamMembers: response.data.members.map(m => {
                        return {
                            id: m.user.id,
                            assign: m.memberType,
                            firstname: m.user.firstName,
                            lastName: m.user.lastName
                        }
                    })} });
                    
                    $( "#addWorkstreamModal" ).modal( "hide" );

                    showToast( "success", "Workstream successfully added!" );
                    
                    dispatch({ type: "UPDATE_WORKSTREAM_FORM_FIELDS", fields: {
                        name: null,
                        type: {},
                        hours: 0,
                        description: null,
                        color: null,
                        workstreamLead: {},
                        isTemplate: false,
                        details: [],
                        users: []
                    }});
                }

                dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                dispatch({ type: "UPDATE_WORKSTREAMS_SELECTED", selected: {} });
                dispatch({ type: "UPDATE_WORKSTREAMS_CHANGES", boolean: true });

                $( ".modal" ).modal( "hide" );
            });
    }

    render() {
        const { workstreamForm } = this.props;
        const isCheckedAll = workstreamForm.fields.users.length === workstreamForm.fields.users.filter( u => u.isSelected ).length;

        return (
            <div class="modal fade confirm-modal accountUsersModal bg-overlay" data-backdrop="static" data-keyboard="false" id="accountUsers">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header bb pd20 pdl40 pdr40">
                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <p class="text-size18 brndnTxt-m text-black mb0 mt5">Add Users to this Account?</p>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2">
                                    <a class="text-right text-black" data-dismiss="modal">
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body pt10 pb10">
                            <p class="m0 mb15">Some internal collaborators of the selected template are not members of this account. Add them anyways?</p>

                            <div class="usersListContainer">
                                <div class="form-group">
                                    <label class="custom-checkbox">
                                        <Checkbox checked={ isCheckedAll } onChange={ this.onSelectAll } />
                                        <div class="user-name-container">
                                            <p>Select All</p>
                                        </div>
                                    </label>
                                </div>
                                { workstreamForm.fields.users.map( u => (
                                    <div class="form-group">
                                        <label class="custom-checkbox">
                                            <Checkbox checked={ u.isSelected } onChange={ () => this.onSelectUsers(u.id) } />
                                            <div class="user-name-container">
                                                <Avatar name="Sample Name" disableTooltip={true} />
                                                <p>{`${ u.firstName } ${ u.lastName }`}</p>
                                            </div>
                                        </label>
                                    </div>
                                ))}
                            </div>

                            <p class="infoNote"><i class="material-icons mr5">info</i>Note: For security purposes, external users are restricted from being added automatically. To add, go to account settings.</p>
                        </div>
                        <div class="modal-footer bt">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <button type="button" class="btn btnCancel ml0" data-dismiss="modal">Cancel</button>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8 text-align-right">
                                    <button type="button" class={`btn btnSave`} onClick={ this.onSubmit }>Proceed</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AccountUsers;
